<template>
  <div class="edit">
    <div class="edit-content">
      <div class="edit-item">
        <div class="title">标题</div>
        <el-input v-model="editForm.label" placeholder="请输入内容"></el-input>
      </div>
      <div class="edit-item">
        <div class="title">提示文字</div>
        <el-input v-model="editForm.placeholder" placeholder="请输入内容"></el-input>
      </div>
      <div class="edit-item">
        <div class="title">默认值</div>
        <el-select v-model="defaultValue" placeholder="请选择" value-key="value" :multiple="true"
          @change="defaultValueChange">
          <el-option v-for="item in editForm.propOptions" :key="item.key" :label="item.value"
            :value="item.key"></el-option>
        </el-select>
      </div>
      <div class="edit-item" v-if="editForm.propOptions">
        <div class="title">选项</div>
        <div :id="editForm.uid">
          <div class="select edit-item2" v-for="(item, index) in editForm.propOptions" :key="index">
            <img src="@/assets/tuozhuai.png" class="tuozhuai" />
            <el-input v-model="item.value" placeholder="请输入内容"></el-input>
            <span @click="removeSelect(index)">
              <i class="el-icon-delete"></i>
            </span>
          </div>
        </div>
        <div class="addedit">
          <span @click="batchClick">批量编辑</span>
          <span @click="addSelect">添加选项</span>
        </div>
      </div>
      <div class="edit-item">
        <div class="title">是否必填</div>
        <el-switch @change="changeRequired" v-model="editForm.required" :active-value="1"
          :inactive-value="0">必填</el-switch>
      </div>
      <div class="edit-item">
        <div class="title">
          参与打印
          <span>(如不勾选，打印时不显示该项)</span>
        </div>
        <el-switch v-model="editForm.pint" :active-value="1" :inactive-value="0">参与打印</el-switch>
      </div>
    </div>
  </div>
</template>

<script>
import Sortable from "sortablejs";
export default {
  props: {
    editForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      defaultValue: this.editForm.defaultValue ? this.editForm.defaultValue.split(',') : ''
    }
  },
  mounted() {
    let el = document.getElementById(this.editForm.uid);
    let that = this;
    // 常用
    new Sortable(el, {
      animation: 150,
      group: {
        name: "shared",
        pull: "clone",
        put: false, // 不允许拖拽进这个列表
      },
      onEnd: function (evt) {
        // 获取排序之后的data数据
        that.editForm.propOptions.splice(
          evt.newIndex,
          0,
          that.editForm.propOptions.splice(evt.oldIndex, 1)[0]
        );
        var newArray = that.editForm.propOptions.slice(0);
        that.editForm.propOptions = [];
        that.$nextTick(function () {
          that.editForm.propOptions = newArray;
        });
      },
    });

  },
  methods: {
    defaultValueChange() {
      this.editForm.defaultValue = this.defaultValue.join(',')
    },
    batchClick() {
      this.$emit("batchClick");
    },
    addSelect() {
      this.$emit("addSelect");
    },
    removeSelect(index) {
      this.$emit("removeSelect", index);
    },
    // 是否必填
    changeRequired(val) {
      // console.log(val);
      // console.log(this.editForm);
      this.$emit("addRequired", this.editForm);
    },
  },
};
</script>

<style lang="scss" scoped>
.tuozhuai {
  width: 20px;
  height: 20px;
}

.draggable-none {
  // margin: 42px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 42px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  color: #999999;

  img {
    margin-right: 16px;
  }
}

.edit-none {
  height: 100%;
  color: #999999;
  position: relative;

  span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.edit-number {
  width: 100%;
  line-height: 40px;
  background-color: #ffeeee;
  color: #d43030;
  font-size: 12px;
  text-align: center;
  margin-bottom: 16px;
}

.edit-title {
  color: #0f66f2;
  margin-bottom: 24px;

  .iconfont {
    margin-right: 8px;
  }
}

.edit-column {
  text-align: center;
  margin: 35% 0 0;
  color: #999999;

  div {
    line-height: 36px;
  }
}

.addedit {
  padding: 12px 0;
  color: #0f66f2;

  span {
    padding: 0 8px;
    cursor: pointer;

    &:nth-of-type(1) {
      border-right: 1px solid #eeeeee;
    }
  }
}

.edit-item {
  margin-bottom: 16px;

  .title {
    margin-bottom: 12px;

    span {
      font-size: 12px;
      color: #999;
    }

    i {
      font-style: normal;
      color: #0f66f2;
    }
  }
}

.edit-item2 {
  margin-bottom: 12px;
}

.edit-have {
  height: 100%;
}

.edit-item-list {
  margin-bottom: 8px;
}

.edit-ul {
  width: 80%;
  margin: 16px auto;

  li {
    display: flex;
    padding: 6px;
    border: 1px solid #eeeeee;

    div {
      width: 50%;
      text-align: center;

      &:nth-of-type(1) {
        border-right: 1px solid #eeeeee;
      }
    }
  }
}
</style>
